import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom, concatMap, mapTo } from 'rxjs/operators';
import { Actions, ofType, Effect } from '@ngrx/effects';
import { Action, Store, select } from '@ngrx/store';
import * as expertiseActions from '../actions/expertise.actions';
import * as fromUI from '../actions/ui.actions';
import { of } from 'rxjs';  
import { ExpertiseService } from '../../shared/services/expertise.service';
import { PrestationService } from '../../shared/services/prestation.service';
import { NotificationsService } from '../../shared/notifications/notifications.service';
import { Expertise } from '../../shared/models/expertise';
import { Location } from '@angular/common';

@Injectable()
export class ExpertiseEffect {

    @Effect()
    loadExpertises$: Observable<any> = this.actions$.pipe(
        ofType(expertiseActions.LOAD_EXPERTISES), 
        switchMap((action) => {   
            return this.expertiseService.getAll(        action['sortField'],
                action['sortOrder'],
                action['filters'],
                action['first'],
                action['rows'], 
                ).pipe(
                map((res: any) => new expertiseActions.LoadExpertisesSuccessAction(res.body.map(e => Object.assign(new Expertise,e)) ,parseInt(res.headers.get('X-Pagination-Total-Count')))),
                catchError(error => of(new expertiseActions.LoadExpertisesErrorAction(error)))
            );
        })        
    );

    @Effect()
    openTab$: Observable<any> = this.actions$.pipe(
        ofType(expertiseActions.OPEN_TAB),        
        switchMap((action) => {            
            return this.expertiseService.get(action['id']).pipe(
                map((res: any) => new expertiseActions.LoadExpertiseSuccessAction(res)),
                catchError(error => of(new expertiseActions.LoadExpertiseErrorAction(error)))
            );
        })
    );    
    @Effect()
    saveExpertise$: Observable<any> = this.actions$.pipe(
        ofType(expertiseActions.SAVE_EXPERTISE),        
        map((action: expertiseActions.SaveExpertiseAction) => action ),
        switchMap((action) => { 
            return this.expertiseService.save(action.expertise).pipe(
                map((res: any) => new expertiseActions.SaveExpertiseSuccessAction(action['expertise']['id'], res)),
                catchError(error => of(new expertiseActions.SaveExpertiseErrorAction(action['expertise']['id'], error)))
            );
        })
    );    

    @Effect({ dispatch: false })
    addExpertise: Observable<any> = this.actions$.pipe(
        ofType(expertiseActions.ADD_EXPERTISE),        
        concatMap(action =>
            of(action).pipe(
              withLatestFrom(this.store.pipe(select('expertise')))
            )
        ),        
        tap(a => {
               this.router.navigateByUrl('/expertise/view/' + a[1].lastNewId);
        })

    );

    @Effect({ dispatch: false })
    closeTab$: Observable<any> = this.actions$.pipe(
        ofType(expertiseActions.CLOSE_TAB),        
        concatMap(action =>
            of(action).pipe(
              withLatestFrom(this.store.pipe(select('expertise')))
            )
        ),        
        tap(a => {
            this.router.navigateByUrl('/expertise/list');
        })

    );

    @Effect()
    updatePrestation: Observable<any> = this.actions$.pipe(
        ofType(expertiseActions.UPDATE_PRESTATION),        
        map((action: expertiseActions.UpdatePrestationAction) => action ),
        switchMap((action) => { 
            let oldId = action.prestation.id;
            return this.prestationService.update(action.prestation.toRequest()).pipe(
                map((res: any) => new expertiseActions.UpdatePrestationSuccessAction(action.expertiseId,oldId,res)),
                catchError(error => of(new expertiseActions.UpdatePrestationErrorAction(action.expertiseId, error)))
            );
        })
    );    

    @Effect()
    expertiseWorkflow: Observable<any> = this.actions$.pipe(
        ofType(expertiseActions.EXPERTISE_WORKFLOW),        
        map((action: expertiseActions.ExpertiseWorkflowAction) => action ),
        switchMap((action) => { 
                    
            return this.expertiseService.doWorkflow(action.id, action.action).pipe(
                map((res: any) => new expertiseActions.ExpertiseWorkflowSuccessAction(action['id'], res)),
                catchError(error => of(new expertiseActions.ExpertiseWorkflowErrorAction(action['id'], error)))
            );
        })
    ); 
    
    @Effect()
    expertiseAddAcompte: Observable<any> = this.actions$.pipe(
        ofType(expertiseActions.EXPERTISE_ACOMPTE),        
        map((action: expertiseActions.ExpertiseAddAcompteAction) => action ),
        switchMap((action) => { 
                    
            return this.expertiseService.addAcompte(action.id, action.amount).pipe(
                map((res: any) => new expertiseActions.ExpertiseWorkflowSuccessAction(action['id'], res)),
                catchError(error => of(new expertiseActions.ExpertiseWorkflowErrorAction(action['id'], error)))
            );
        })
    );    

    @Effect({dispatch: false})
    expertiseWorkflowError: Observable<any> = this.actions$.pipe(
        ofType(expertiseActions.EXPERTISE_WORKFLOW_ERROR),        
        map((action: expertiseActions.ExpertiseWorkflowErrorAction) => action ),
        tap((action) => { 
            this.notificationsService.growlNotify('error','Erreur',action.error.message );
        })
    );  

  @Effect()
    deleteExpertise$: Observable<any> = this.actions$.pipe(
        ofType(expertiseActions.DELETE_EXPERTISE),        
        map((action: expertiseActions.DeleteExpertiseAction) => action ),
        switchMap((action) => { 
            console.log('save expertise', action);           
            return this.expertiseService.delete(action.id).pipe(
                map((res: any) => new expertiseActions.DeleteExpertiseSuccessAction(action['id'])),
                catchError(error => of(new expertiseActions.DeleteExpertiseErrorAction(action['id'], error)))
            );
        })
    );    


    @Effect({dispatch: false})
    deleteExpertiseError: Observable<any> = this.actions$.pipe(
        ofType(expertiseActions.DELETE_EXPERTISE_ERROR),        
        map((action: expertiseActions.DeleteExpertiseAction) => action ),
        tap((action) => { 
            this.notificationsService.growlNotify('error','Erreur',action.error.message );
        })
    );  

    @Effect({ dispatch: false })
    deleteExpertiseSuccess$: Observable<any> = this.actions$.pipe(
        ofType(expertiseActions.DELETE_EXPERTISE_SUCCESS),        
        concatMap(action =>
            of(action).pipe(
              withLatestFrom(this.store.pipe(select('expertise')))
            )
        ),        
        tap(a => {
            this._location.back();
        })

    );

  @Effect()
    deletePrestation$: Observable<any> = this.actions$.pipe(
        ofType(expertiseActions.DELETE_PRESTATION),        
        map((action: expertiseActions.DeletePrestationAction) => action ),
        switchMap((action) => {             
            return this.prestationService.delete(action.id).pipe(
                map((res: any) => new expertiseActions.DeletePrestationSuccessAction(action['expertiseId'],action['id'])),
                catchError(error => of(new expertiseActions.DeletePrestationErrorAction(action['id'], error)))
            );
        })
    );    


    @Effect({dispatch: false})
    deletePrestationError: Observable<any> = this.actions$.pipe(
        ofType(expertiseActions.DELETE_PRESTATION_ERROR),        
        map((action: expertiseActions.DeletePrestationAction) => action ),
        tap((action) => { 
            this.notificationsService.growlNotify('error','Erreur',action.error.message );
        })
    );  

    constructor(
        private actions$: Actions,
        private store: Store<any>,
        private router: Router,
        private expertiseService: ExpertiseService,
        private prestationService: PrestationService,
        private notificationsService: NotificationsService,
        private _location: Location
    ) {}
}
